(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8915],{

/***/ 73525:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/privacy",
      function () {
        return __webpack_require__(42410);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 12651:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SEO; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23934);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51834);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var constants_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34741);
/* harmony import */ var constants_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30300);
/* harmony import */ var contexts_settings_settings_context__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85286);





function SEO(param) {
    let { title , description =constants_config__WEBPACK_IMPORTED_MODULE_3__/* .META_DESCRIPTION */ .KM , image =constants_config__WEBPACK_IMPORTED_MODULE_3__/* .META_IMAGE */ .T5 , keywords =constants_config__WEBPACK_IMPORTED_MODULE_3__/* .META_KEYWORDS */ .cU  } = param;
    const { settings  } = (0,contexts_settings_settings_context__WEBPACK_IMPORTED_MODULE_4__/* .useSettings */ .r)();
    const projectTitle = (settings === null || settings === void 0 ? void 0 : settings.title) || constants_config__WEBPACK_IMPORTED_MODULE_3__/* .META_TITLE */ .k5;
    const currentURL = constants_constants__WEBPACK_IMPORTED_MODULE_2__/* .WEBSITE_URL */ .o6;
    const siteTitle = title ? title + " | " + projectTitle : projectTitle;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "viewport",
                content: "width=device-width, initial-scale=1"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                charSet: "utf-8"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: siteTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: keywords
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: "Website"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "title",
                property: "og:title",
                content: siteTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "author",
                property: "og:author",
                content: currentURL
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:site_name",
                content: currentURL
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "image",
                property: "og:image",
                content: image
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: "summary"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: siteTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:site",
                content: currentURL
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:creator",
                content: currentURL
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: image
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "icon",
                href: (settings === null || settings === void 0 ? void 0 : settings.favicon) || "/favicon.png"
            })
        ]
    });
}


/***/ }),

/***/ 78904:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Content; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23934);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59108);
/* harmony import */ var _content_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85950);
/* harmony import */ var _content_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_content_module_scss__WEBPACK_IMPORTED_MODULE_2__);



function Content(param) {
    let { data  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_content_module_scss__WEBPACK_IMPORTED_MODULE_2___default().container),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "container",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_content_module_scss__WEBPACK_IMPORTED_MODULE_2___default().header),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                            className: (_content_module_scss__WEBPACK_IMPORTED_MODULE_2___default().title),
                            children: data === null || data === void 0 ? void 0 : data.title
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: (_content_module_scss__WEBPACK_IMPORTED_MODULE_2___default().text)
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("main", {
                    className: (_content_module_scss__WEBPACK_IMPORTED_MODULE_2___default().content),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        dangerouslySetInnerHTML: {
                            __html: (data === null || data === void 0 ? void 0 : data.description) || ""
                        }
                    })
                })
            ]
        })
    });
}


/***/ }),

/***/ 42410:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ Privacy; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23934);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59108);
/* harmony import */ var components_seo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12651);
/* harmony import */ var containers_content_content__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78904);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(65084);
/* harmony import */ var services_faq__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(58629);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82807);







var __N_SSG = true;
function Privacy(param) {
    let {} = param;
    var ref, ref1, ref2;
    const { i18n  } = (0,react_i18next__WEBPACK_IMPORTED_MODULE_6__/* .useTranslation */ .$G)();
    const locale = i18n.language;
    const { data , error  } = (0,react_query__WEBPACK_IMPORTED_MODULE_4__.useQuery)([
        "privacy",
        locale
    ], ()=>services_faq__WEBPACK_IMPORTED_MODULE_5__/* ["default"].getPrivacy */ .Z.getPrivacy());
    if (error) {
        console.log("error => ", error);
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_seo__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                title: data === null || data === void 0 ? void 0 : (ref = data.data) === null || ref === void 0 ? void 0 : (ref1 = ref.translation) === null || ref1 === void 0 ? void 0 : ref1.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(containers_content_content__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                data: data === null || data === void 0 ? void 0 : (ref2 = data.data) === null || ref2 === void 0 ? void 0 : ref2.translation
            })
        ]
    });
}


/***/ }),

/***/ 58629:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36155);

const faqService = {
    getAll: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/faqs/paginate", {
            params
        }),
    getPrivacy: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/policy", {
            params
        }),
    getTerms: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/term", {
            params
        })
};
/* harmony default export */ __webpack_exports__["Z"] = (faqService);


/***/ }),

/***/ 85950:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"content_container__aim2s","header":"content_header__G6IRy","title":"content_title__2iCsS","text":"content_text__cX4Xb","content":"content_content__twclt"};

/***/ }),

/***/ 51834:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(58761)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(73525); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);